<template>
  <div class="projectPage">
    <Header
      :menuIndex="1"
      :banner="bannerImg"
      mainTitle="岩土勘察数据分析（YTKC软件）"
      mainTitleColor="#fff"
      subTitle="助力数字化转型"
      subTitleColor="#fff"
    />
    <div class="navBar">
      <div class="container">
        <div
          class="item"
          v-for="(item, index) in navBarList"
          :key="index"
          :class="{ active: activeIndex == index }"
          @click="changeActiveIndex(index)"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <div class="container" ref="sectionA">
      <section class="sectionA">
        <div class="sec-title">{{ navBarList[0] }}</div>
        <div class="content">
          <div class="item" v-for="(item, index) in sectionAList" :key="index">
            <img :src="item.img" alt="" />
            <div class="info">
              <div class="title">{{ item.title }}</div>
              <div class="desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <section class="sectionB" ref="sectionB">
      <div class="container">
        <div class="sec-title">{{ navBarList[1] }}</div>
        <div class="content">
          <div class="item" v-for="(item, index) in sectionBList" :key="index">
            <img :src="item.img" alt="" />
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </section>
    <div class="container" ref="sectionC">
      <section class="sectionC">
        <div class="sec-title">{{ navBarList[2] }}</div>
        <div class="sec-sub-title">
          精准计算，生成多样化勘察图纸
        </div>
        <div class="content">
          <div class="tabs">
            <div
              class="item"
              :class="{ active: sectionCActiveIndex == index }"
              v-for="(item, index) in sectionCList"
              :key="index"
              @click="changeSectionC(index)"
            >
              <div class="tab" v-if="sectionCActiveIndex != index">
                {{ item.title }}
              </div>
              <div class="detail" v-if="sectionCActiveIndex == index">
                <div class="title">{{ item.title }}</div>
                <div class="desc">
                  <span v-for="(item_s, indes_s) in item.desc" :key="indes_s">{{
                    item_s
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <img :src="sectionCList[sectionCActiveIndex].img" alt="" />
        </div>
      </section>
    </div>
    <div class="contactus">
      <div class="title">从这里开始，让数据用起来</div>
      <div class="btn" @click="$router.push('/application')">联系我们</div>
    </div>
    <Foot />
  </div>
</template>

<script>
export default {
  data() {
    return {
      bannerImg: require("@/assets/banner/4.jpg"),
      navBarList: ["产品优势", "核心功能", "产品展示"],
      activeIndex: 0,
      sectionAList: [
        {
          img: require("@/assets/chanpinyoushi/1.png"),
          title: "长期稳定应用",
          desc:
            "YTKC软件在过去20多年间一直得到广泛应用和迭代，证明其在勘察项目中的长期稳定性和可靠性",
        },
        {
          img: require("@/assets/chanpinyoushi/2.png"),
          title: "多功能性",
          desc:
            "概预算、工作量统计、土层统计、试验指标统计等，满足了勘察项目中各种需求的统计和计算要求",
        },
        {
          img: require("@/assets/chanpinyoushi/3.png"),
          title: "全面的勘察图纸生成",
          desc:
            "生成各种勘察所需的图纸，如勘探点平面位置图、工程地质剖面图、地层层面等值线图等，为勘察工作提供全面的视觉支持",
        },
        {
          img: require("@/assets/chanpinyoushi/4.png"),
          title: "准确计算功能",
          desc:
            "准确的计算，如土层沉降量、单桩承载力、黄土湿陷量、边坡安全系数等，帮助用户进行可靠的工程计算",
        },
        {
          img: require("@/assets/chanpinyoushi/5.png"),
          title: "广泛引进和应用",
          desc:
            "已被陕西多家勘察单位引进，并在国内外勘察项目中广泛应用，证明其在实际工程中的可行性和价值",
        },
        {
          img: require("@/assets/chanpinyoushi/6.png"),
          title: "用户友好界面",
          desc:
            "具有用户友好的界面设计，使得用户能够轻松上手并高效地操作，提升工作效率",
        },
      ],
      sectionBList: [
        {
          img: require("@/assets/hexingongneng/1.png"),
          title: "综合统计与计算",
          desc:
            "概预算、工作量统计、土层统计、试验指标统计等功能，帮助用户进行全面的统计分析和工程计算，实现高效的数据处理和决策支持",
        },
        {
          img: require("@/assets/hexingongneng/2.png"),
          title: "土层特性计算",
          desc:
            "计算土层沉降量、单桩承载力、黄土湿陷量、边坡安全系数等关键土层特性，为工程设计和评估提供可靠的指标和数据支持",
        },
        {
          img: require("@/assets/hexingongneng/3.png"),
          title: "图纸生成与展示",
          desc:
            "具备生成多种勘察所需图纸的能力，如勘探点平面位置图、工程地质剖面图、地层层面等值线图、水位等值线图等，直观展示勘察结果和地质特征",
        },
        {
          img: require("@/assets/hexingongneng/4.png"),
          title: "数据分析与可视化",
          desc:
            "支持颗粒分析级配曲线图、钻孔柱状图、波速测试图、试验指标随深度变化图等数据分析与可视化功能，帮助用户深入了解地质特征和工程性质",
        },
        {
          img: require("@/assets/hexingongneng/5.png"),
          title: "数据管理与导入导出",
          desc:
            "提供便捷的数据管理功能，用户可以轻松导入、导出和管理勘察数据，保证数据的完整性和可追溯性",
        },
        {
          img: require("@/assets/hexingongneng/6.png"),
          title: "地质信息展示与分析",
          desc:
            "支持地质信息的展示和分析，包括地层层面等值线图和水位等值线图，帮助用户深入了解地质情况，进行地质特征的分析和评估",
        },
      ],
      sectionCList: [
        {
          title: "数据智能计算",
          desc: ["计算精准", "多维数据", "高度配置"],
          img: require("@/assets/ytkc/show3.png"),
        },
        {
          title: "数据分析与导出",
          desc: ["数据完整性", "可追溯性", "便携性"],
          img: require("@/assets/ytkc/show5.png"),
        },
        {
          title: "图纸生成展示",
          desc: ["多样化图纸生成", "直观展示地质特征"],
          img: require("@/assets/ytkc/show1.png"),
        },
        {
          title: "地质信息分析",
          desc: ["数据可读性", "层面等值线图", "水位等值线图"],
          img: require("@/assets/ytkc/show2.png"),
        },
      ],
      sectionCActiveIndex: 0,
    };
  },
  mounted() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const observer1 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeIndex = 0;
        }
      });
    }, options);

    observer1.observe(this.$refs.sectionA);

    const observer2 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeIndex = 1;
        }
      });
    }, options);

    observer2.observe(this.$refs.sectionB);

    const observer3 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeIndex = 2;
        }
      });
    }, options);

    observer3.observe(this.$refs.sectionC);
  },
  methods: {
    changeActiveIndex(index) {
      this.activeIndex = index;
      switch (index) {
        case 0:
          this.$refs.sectionA.scrollIntoView({ behavior: "smooth" });
          break;
        case 1:
          this.$refs.sectionB.scrollIntoView({ behavior: "smooth" });
          break;
        case 2:
          this.$refs.sectionC.scrollIntoView({ behavior: "smooth" });
          break;
      }
    },
    changeSectionC(index) {
      this.sectionCActiveIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 1280px;
  margin: 0 auto;
}
.projectPage {
  .navBar {
    height: 55px;
    position: sticky;
    z-index: 100;
    top: 0;
    background-color: #fff;
    box-shadow: 0 1px 1px 0 #ebedf6;
    > .container {
      display: flex;
      align-items: center;
      .item {
        cursor: pointer;
        margin-right: 50px;
        font-size: 16px;
        line-height: 55px;
        color: #7a8ba6;
        position: relative;
        &::after {
          content: "";
          width: 100%;
          height: 2px;
          background-image: linear-gradient(90deg, #659eff 0, #2466ff 100%);
          position: absolute;
          bottom: 0;
          left: 0;
          opacity: 0;
          transition: all 0.3s;
        }
      }
      .item.active {
        &::after {
          opacity: 1;
        }
      }
    }
  }
  section {
    .sec-title {
      font-size: 28px;
      font-weight: 500;
      line-height: 48px;
      color: #374567;
      text-align: center;
      width: 100%;
      padding-bottom: 72px;
      padding-top: 72px;
    }
  }
  .sectionA {
    padding-bottom: 72px;
    & > .content {
      display: grid;
      column-gap: 150px;
      row-gap: 70px;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 132px 132px;
      .item {
        display: flex;
        img {
          width: 30px;
          height: 30px;
          margin-right: 15px;
        }
        .info {
          .title {
            color: #374567;
            font-size: 18px;
            font-weight: 600;
            line-height: 32px;
          }
          .desc {
            margin-top: 16px;
            color: #7a8ba6;
            width: 100%;
            overflow: hidden;
            font-size: 14px;
            line-height: 24px;
            text-align: justify;
          }
        }
      }
    }
  }
  .sectionB {
    width: 100%;
    background-color: #f9faff;
    padding-bottom: 80px;
    .content {
      display: grid;
      column-gap: 25px;
      row-gap: 25px;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 344px 344px;
      .item {
        position: relative;
        background-color: #fff;
        img {
          position: absolute;
          width: 148px;
          height: 148px;
          bottom: 5px;
          right: 14px;
        }
        .title {
          font-weight: 600;
          margin-left: 32px;
          margin-top: 32px;
          height: 32px;
          font-size: 18px;
          color: #374567;
          line-height: 32px;
          text-align: left;
        }
        .desc {
          margin-right: 32px;
          padding-top: 8px;
          margin-left: 32px;
          letter-spacing: 1.5px;
          font-size: 14px;
          text-align: justify;
          color: #7a8ba6;
          line-height: 24px;
        }
      }
    }
  }
  .sectionC {
    width: 100%;
    padding-bottom: 80px;
    .sec-title {
      font-size: 28px;
      font-weight: 500;
      line-height: 48px;
      color: #374567;
      text-align: center;
      padding: 70px 0 0 0;
    }
    .sec-sub-title {
      font-size: 14px;
      color: #7a8ba6;
      line-height: 24px;
      max-width: 1280px;
      margin: 24px auto 72px auto;
      text-align: center;
    }
    .content {
      width: 100%;
      .tabs {
        width: 100%;
        display: flex;
        background-color: #f9faff;
        .item {
          flex: 1;
          height: 136px;
          cursor: pointer;
          .tab {
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 18px;
            color: #374567;
            font-weight: 500;
            text-align: center;
          }
          .detail {
            .title {
              margin-top: 32px;
              margin-left: 24px;
              font-weight: 600;
              font-size: 18px;
              color: #374567;
              line-height: 24px;
              text-align: left;
              height: 24px;
              width: 352px;
            }
            .desc {
              margin-top: 10px;
              margin-left: 24px;
              font-size: 14px;
              color: #7a8ba6;
              line-height: 24px;
              span {
                margin-right: 12px;
              }
            }
          }
        }
        .item.active {
          width: 455px;
          height: 136px;
          border-top: 4px solid #2468ff;
          background-color: #fff;
        }
      }
      img {
        width: 100%;
        height: 720px;
      }
    }
  }
  .contactus {
    width: 100%;
    height: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-image: linear-gradient(
      90deg,
      rgb(251, 252, 255),
      rgb(228, 234, 252) 75%,
      rgb(202, 222, 255)
    );
    .title {
      font-size: 30px;
      line-height: 40px;
      letter-spacing: 1.88px;
      text-align: center;
      color: #181818;
      padding-top: 49px;
      font-weight: 500;
    }
    .btn {
      margin-top: 20px;
      width: 108px;
      height: 36px;
      border-radius: 18px;
      background-image: linear-gradient(
        90deg,
        rgb(124, 172, 255),
        rgb(98, 140, 255)
      );
      margin: 20px auto;
      font-size: 14px;
      color: #fff;
      line-height: 36px;
      cursor: pointer;
      text-align: center;
      &:hover {
        background-image: linear-gradient(
          90deg,
          rgb(113, 165, 255),
          rgb(78, 125, 252)
        );
      }
    }
  }
}
</style>
